export default __webpack_public_path__ + "gen-ai.90993f86.svg";